/* eslint-disable react/prop-types */
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setRemoteConfigLoading,
  updateRemoteConfig,
} from "redux/actions/remoteActions";
import { onUpdateRemoteConfig } from "services/rconfig";
import { EventEmitter } from "utils/EventEmitter";
import { getParamValue } from "utils/rcUtils";
import useLocalStorage from "./useLocalStorage";

const key = "imtime-version";
const RCProvider = (props) => {
  const dispatch = useDispatch();
  const [value, setLocalValue] = useLocalStorage(key, null);
  const [currentVersion, setCurrentVersion] = useState(null);
  const RC = useSelector((state) => state.remote);
  const [startTS] = useState(moment());
  const [lastUpdated, setLastUpdated] = useState();

  useEffect(() => {
    console.log("RC", RC);
  }, [RC]);

  useEffect(() => {
    dispatch(setRemoteConfigLoading(true));
    onUpdateRemoteConfig(async (data) => {
      try {
        if (data && data.config) {
          const { config, ...rest } = data;
          const updated = moment(rest.lastUpdated.toDate());
          setLastUpdated(updated);
          const version = getParamValue(config, "version");
          dispatch(updateRemoteConfig({ data: rest, config }));
          dispatch(setRemoteConfigLoading(false));
          setCurrentVersion(version);
          EventEmitter.dispatch("versionChange", version);
        }
      } catch (e) {
        console.log("Error in fetching remote config", e);
      }
    });
  }, []);

  useEffect(() => {
    const oldVersion = value;
    if (oldVersion && currentVersion) {
      if (oldVersion !== currentVersion) {
        console.log("RC TS", startTS.format(), lastUpdated.format());
        // config update time is greater than app start time
        // In this case the popup must be shown
        EventEmitter.dispatch("showUpdatePopup", {
          version: currentVersion,
          timer: startTS.isSameOrBefore(lastUpdated),
        });
        setLocalValue(currentVersion);
      }
    } else {
      if (currentVersion != null) setLocalValue(currentVersion);
    }
    console.log("Values", oldVersion, currentVersion);
  }, [value, currentVersion]);

  return <>{props.children}</>;
};

export default RCProvider;
